"use client"

import { useState } from "react"

export default function CreateGroupForm() {
  const [name, setName] = useState("")
  const [parentGroupId, setParentGroupId] = useState("")
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError("")
    setSuccess("")
    try {
      const res = await fetch("/api/groups", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, parentGroupId: parentGroupId || undefined }),
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.error || "Failed to create group")
      setSuccess("Group created successfully!")
      setName("")
      setParentGroupId("")
    } catch (err: any) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className="max-w-md mx-auto p-4 border rounded mt-8">
      <h2 className="text-lg font-bold mb-4">Create Group / Sub-group</h2>
      <div className="mb-4">
        <label className="block mb-1">Group Name</label>
        <input
          className="w-full border px-2 py-1 rounded"
          value={name}
          onChange={e => setName(e.target.value)}
          required
        />
      </div>
      <div className="mb-4">
        <label className="block mb-1">Parent Group ID (optional for sub-group)</label>
        <input
          className="w-full border px-2 py-1 rounded"
          value={parentGroupId}
          onChange={e => setParentGroupId(e.target.value)}
        />
      </div>
      <button
        type="submit"
        className="bg-blue-600 text-white px-4 py-2 rounded"
        disabled={loading}
      >
        {loading ? "Creating..." : "Create"}
      </button>
      {error && <div className="text-red-600 mt-2">{error}</div>}
      {success && <div className="text-green-600 mt-2">{success}</div>}
    </form>
  )
}
